import React, { createContext, useContext } from 'react';
import useMatchLGBreakpoint from '../../hooks/use-match-lg-breakpoint';
import useMatchMDBreakpoint from '../../hooks/use-match-md-breakpoint';

const EditorHeaderContext = createContext({
  isLg: false,
  isMd: false,
});

export const EditorHeaderProvider = ({ children = null }) => {
  const isLg = useMatchLGBreakpoint();
  const isMd = useMatchMDBreakpoint();

  return (
    <EditorHeaderContext.Provider value={{ isLg, isMd }}>{children}</EditorHeaderContext.Provider>
  );
};

export const useEditorHeaderContext = () => {
  const context = useContext(EditorHeaderContext);

  if (context === undefined) {
    throw new Error('useEditorHeaderContext should be used within EditorHeaderProvider');
  }

  return context;
};
